import { render, staticRenderFns } from "./MemberGroup.vue?vue&type=template&id=44dde108&"
import script from "./MemberGroup.vue?vue&type=script&lang=js&"
export * from "./MemberGroup.vue?vue&type=script&lang=js&"
import style0 from "./MemberGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports